import React from "react";
import Our from "./Our/Our";
import Filter from "./Filter/Filter";
import Special from "./Special/Special";
import Get from "./Get/Get";
import Logo from "./Logo/Logo";
import Reviews from "./Reviews/Reviews";

const Fadeout = () => {
  return (
    <>
      <Our />
      <Filter />
      <Special />
      <Get />
      <Logo />
      <Reviews />
    </>
  );
};

export default Fadeout;
